export { resolveNodeType } from './resolveNodeType';
